// THIS IS A GENERATED FILE, DO NOT EDIT
import { __assign } from "tslib";
import * as React from 'react';
import { Icon } from '../Icon';
export default React.forwardRef(function CaretsInVertical(props, ref) {
    return (React.createElement(Icon, __assign({}, props, { name: "CaretsInVertical" }),
        React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: ref },
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.5 3L19.5 3L12 11.25L4.5 3Z", fill: "currentColor" }),
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19.5 21H4.5L12 12.75L19.5 21Z", fill: "currentColor" }))));
});
//# sourceMappingURL=CaretsInVertical.js.map